import React, { useState, useEffect } from "react";
import axios from "../api/axiosConfig";
import Navbar from "../components/Navbar";

export default function Models() {
  const [models, setModels] = useState([]);
  const [newName, setNewName] = useState("");
  const [loading, setLoading] = useState(false);

  // Edit State
  const [editingId, setEditingId] = useState(null);
  const [editName, setEditName] = useState("");

  useEffect(() => {
    fetchModels();
  }, []);

  const fetchModels = async () => {
    try {
      const { data } = await axios.get("/models");
      setModels(data);
    } catch (error) {
      console.error("Error fetching models", error);
    }
  };

  const handleAdd = async (e) => {
    e.preventDefault();
    if (!newName.trim()) return;
    try {
      setLoading(true);
      await axios.post("/models/add", { name: newName });
      setNewName("");
      fetchModels();
    } catch (error) {
      alert("Failed to add model. It might already exist.");
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this model?")) return;
    try {
      await axios.delete(`/models/${id}`);
      fetchModels();
    } catch (error) {
      alert("Failed to delete model.");
    }
  };

  const handleUpdate = async (id) => {
    if (!editName.trim()) return;
    try {
      await axios.put(`/models/${id}`, { name: editName });
      setEditingId(null);
      setEditName("");
      fetchModels();
    } catch (error) {
       if (error.response && error.response.data.message) {
          alert(error.response.data.message);
      } else {
          alert("Failed to update.");
      }
    }
  };

  return (
    <>
      <Navbar />
      <div className="container py-5 animate-fade-in" style={{ maxWidth: '700px' }}>
        <h3 className="fw-bold text-primary mb-4">Manage Models</h3>
        
        {/* ADD CARD */}
        <div className="card shadow-sm p-4 mb-4">
            <h6 className="fw-bold text-muted text-uppercase mb-3">Add New Model</h6>
            <form onSubmit={handleAdd} className="d-flex gap-2">
                <input 
                    className="form-control" 
                    placeholder="E.g. iPhone 15 Pro" 
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                />
                <button className="btn btn-primary px-4" disabled={loading}>
                    {loading ? "..." : "Add"}
                </button>
            </form>
        </div>

        {/* LIST */}
        <div className="card shadow-sm">
            <div className="card-header bg-white py-3">
                <h6 className="mb-0 fw-bold text-primary">Existing Models ({models.length})</h6>
            </div>
            <ul className="list-group list-group-flush">
                {models.map((m) => (
                    <li key={m._id} className="list-group-item p-3">
                        {editingId === m._id ? (
                            <div className="d-flex gap-2">
                                <input 
                                    className="form-control form-control-sm" 
                                    value={editName} 
                                    onChange={(e) => setEditName(e.target.value)}
                                    autoFocus
                                />
                                <button className="btn btn-sm btn-success" onClick={() => handleUpdate(m._id)}>Save</button>
                                <button className="btn btn-sm btn-light border" onClick={() => setEditingId(null)}>Cancel</button>
                            </div>
                        ) : (
                            <div className="d-flex justify-content-between align-items-center">
                                <span className="fw-medium text-dark">{m.name}</span>
                                <div className="d-flex gap-2">
                                    <button className="btn btn-sm btn-outline-secondary border-0" onClick={() => { setEditingId(m._id); setEditName(m.name); }}>
                                        <i className="bi bi-pencil"></i>
                                    </button>
                                    <button className="btn btn-sm btn-outline-danger border-0" onClick={() => handleDelete(m._id)}>
                                        <i className="bi bi-trash"></i>
                                    </button>
                                </div>
                            </div>
                        )}
                    </li>
                ))}
                {models.length === 0 && <li className="list-group-item text-center text-muted py-4">No models found.</li>}
            </ul>
        </div>
      </div>
    </>
  );
}